import { useEffect, useState } from 'react';

import Base from '../../../utils/base'
import CustomTable from '../../../layout/custom_table/index'

export default function Blog() {
  var base = new Base()
  const [arr_header, set_arr_header] = useState([
    {
      label: base.i18n.t('image'),
      data: 'file_name',
      type: 'image',
    },
    {
      label: base.i18n.t('title'),
      data: 'title',
    },
    {
      label: base.i18n.t('content'),
      data: 'content',
    },
    {
      label: base.i18n.t('total_comment'),
      data: 'total_comment',
    },
    {
      label: base.i18n.t('total_viewer'),
      data: 'total_viewer',
    },
    {
      label: base.i18n.t('status_publish'),
      data: 'status_publish',
    },
  ])
  const [arr, set_arr] = useState([])

  function on_update_data(arr){
    arr.forEach((data, index) => {
      if(data.file_name != null)
        data.file_name = base.host + '/image/blog?file_name=' + data.file_name
      data.total_viewer = data.total_viewer.toLocaleString(base.locale_string)
      data.total_comment = data.total_comment.toLocaleString(base.locale_string)
      data.status_publish = data.is_publish === 1 ? 'Published' : 'Unpublished'
      if(data.title == null)
        data.title = '-'
      if(data.content == null)
        data.content = '-'
    })
    set_arr(arr)
  }

  return (
    <div>
      <h3>{base.i18n.t('blog')}</h3>
      <CustomTable
        url='/blog'
        arr_header={arr_header}
        arr={arr}
        url_update='/blog/action'
        url_create='/blog/action'
        url_delete='/blog'
        on_update_data={data => on_update_data(data)}/>
    </div>
  );
}
